import { Text } from '@mantine/core';

import { Paper } from '@/module/Author/Paper/model/PaperTypes';

import { JournalVolume } from '@feature/utils';

interface JournalCardContentProps {
  paper: Paper;
}

export function JournalCardContent({ paper }: JournalCardContentProps) {
  const { journal, volume, volumeNo, noOfPages, endPage, startPage, journalType } = paper;
  return (
    <>
      {journal && (
        <>
          <Text>
            {journal.title} {journalType?.name ? `(${journalType?.name})` : ''}
          </Text>
          <JournalVolume
            volume={volume}
            volumeNo={volumeNo}
            noOfPages={noOfPages}
            endPage={endPage}
            startPage={startPage}
          />
        </>
      )}
    </>
  );
}
